import classNames from 'classnames';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';

import { modelOf } from '../../../prop-types';
import ConfigStore from '../../../store/ConfigStore';
import UIStore from '../../../store/UIStore';
import AdZones from '../../../types/AdZones';
import BannerStyle from '../../../types/banner/BannerStyle';
import BannerSlider from '../BannerSlider/BannerSliderSlides';

const ASPECT_RATIO = 2.85;

const MainBanner = ({
  configStore,
  uiStore,
  className,
  searchParams,
  overrideSettings,
}) => {
  const getMainBannerSettings = () => {
    const style = configStore.banner.mainBanner.style;
    let styleSettings = {};

    switch (style) {
      case BannerStyle.INFINITE:
        styleSettings = {
          infinite: true,
        };
        break;
      case BannerStyle.CENTERED:
        styleSettings = {
          centerMode: true,
        };
        break;
      case BannerStyle.BOTH:
        styleSettings = {
          infinite: true,
          centerMode: true,
        };
        break;
      default:
        styleSettings = {};
        break;
    }

    return styleSettings;
  };

  const bannerSettings = {
    ...overrideSettings,
    ...getMainBannerSettings(),
  };

  return (
    <BannerSlider
      adZone={AdZones.MAIN_BANNER}
      searchParams={{
        ...searchParams,
      }}
      className={classNames('MainBanner', className)}
      aspectRatio={ASPECT_RATIO}
      maximumCrossAxisSize={
        uiStore.isMobile
          ? window.innerWidth / ASPECT_RATIO
          : configStore.banner.mainBanner.height
      }
      overrideSettings={bannerSettings}
    />
  );
};

MainBanner.propTypes = {
  configStore: modelOf(ConfigStore).isRequired,
  uiStore: modelOf(UIStore).isRequired,
  className: PropTypes.string,
  overrideSettings: PropTypes.object,
  searchParams: PropTypes.object,
};

export default inject((stores) => ({
  configStore: stores.configStore,
  uiStore: stores.uiStore,
}))(observer(MainBanner));
